import { api } from "app/utils/api";
import { getEndpoint } from "app/utils/service";

export const customServices = [
    {
        key: getEndpoint(api.prefixes.user.main),
        text: "Kullanıcı Listesi Servisi"
    }]